module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.ttf?eb91f7b948a42799f67808dd728823b7";